import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, QrCode, ShoppingBag } from "lucide-react";
import qrIllustration from "@/assets/qr-scan-illustration.jpg";

const QrScanRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate QR scan redirect delay
    const timer = setTimeout(() => {
      // Auto redirect after 3 seconds, but user can click earlier
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleRedirectToCatalog = () => {
    navigate("/#catalog");
  };

  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-gradient-card border-none shadow-independence animate-fade-in-up">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-4 relative">
            <img
              src={qrIllustration}
              alt="QR Scan Success"
              className="w-32 h-32 mx-auto rounded-lg shadow-soft"
            />
            <div className="absolute -top-2 -right-2 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center animate-bounce">
              <CheckCircle className="w-5 h-5 text-white" />
            </div>
          </div>
          
          <CardTitle className="text-2xl font-bold text-foreground mb-2">
            QR Code Berhasil di-Scan!
          </CardTitle>
          
          <p className="text-muted-foreground">
            Selamat datang di Bazaar Kemerdekaan Digital! 
            Anda akan diarahkan ke katalog produk.
          </p>
        </CardHeader>

        <CardContent className="text-center space-y-4">
          {/* Loading Animation */}
          <div className="flex justify-center items-center space-x-2 py-4">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce delay-100" />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce delay-200" />
          </div>

          <p className="text-sm text-muted-foreground mb-6">
            Mohon tunggu sebentar...
          </p>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button 
              variant="independence" 
              className="w-full"
              onClick={handleRedirectToCatalog}
            >
              <ShoppingBag className="w-4 h-4" />
              Lanjut ke Katalog
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => navigate("/")}
            >
              <QrCode className="w-4 h-4" />
              Kembali ke Beranda
            </Button>
          </div>

          {/* Info */}
          <div className="mt-6 p-4 bg-accent/10 rounded-lg">
            <div className="flex items-center justify-center space-x-2 text-accent-foreground">
              <CheckCircle className="w-4 h-4" />
              <span className="text-sm font-medium">Scan berhasil!</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              Terima kasih telah menggunakan layanan kami
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QrScanRedirect;